import { Component, OnInit,Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';
import { Afiliado } from '../../models/afiliado/afiliado.model';
import { Usuario } from '../../models/usuario/usuario.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-afiliacion-tab3',
  templateUrl: '../../pages/afiliacion/afiliacion.tab3.html',
  styleUrls: ['../../pages/afiliacion/afiliacion.tab.component.css']
})
export class AfiliacionTab3Component implements OnInit {

    rol:string = localStorage.getItem("rol")
    nombreUsuario: string = localStorage.getItem("nombreUsuario")
    @Input() afiliado: Afiliado;
   
    diasDiferencia: any;
    cursos: any[]; postulantes: any[];
    sistemaSalud: any

    constructor(private router:Router, private escolaridadService:EscolaridadService,
        //        @Inject(MAT_DIALOG_DATA) public data: AfiliacionTab2Component, 
           
                private productosService:ProductosService, private dialog: MatDialog,
                private mantenedorService: MantenedorUsuariosService) { }

    ngOnInit(): void
    {   
        let vm = this
     //   this.mantenedorService.traeSistemaSalud().then( sistemas => vm.data.sistemaSalud = sistemas )
    }

    
   

  

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir()
    {
        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' }  }
        });

        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed) { this.router.navigate(['/index']); }
        });
    }
}
